import { CardTokenResponse } from '@core/models';
import { Observable } from 'rxjs';
import {
	CheckoutAssociatedCardGateway,
	CheckoutAssociatedCardRequest,
	CheckoutAssociatedCardStrategy,
} from '../interfaces/checkout-credit-card.interface';

export class GuestAssociatedCardStrategy implements CheckoutAssociatedCardStrategy {
	create(
		request: CheckoutAssociatedCardRequest,
		gateway: CheckoutAssociatedCardGateway
	): Observable<CardTokenResponse> {
		return gateway.createGuest(request.token, request.customerData);
	}
}
